"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const CompRegoFullButOpenIcon = createIcon({
  displayName: "CompRegoFullButOpenIcon",
  viewBox: "0 0 45 33.58",
  path: (
    <>
      <path
        d="M16.77,16.81c-2.31,0-4.28-.82-5.93-2.47-1.63-1.63-2.47-3.63-2.47-5.93s.82-4.28,2.47-5.93c1.63-1.63,3.63-2.47,5.93-2.47s4.28.82,5.93,2.47c1.66,1.66,2.47,3.63,2.47,5.93s-.82,4.28-2.47,5.93c-1.63,1.63-3.63,2.47-5.93,2.47ZM0,33.58v-5.87c0-1.19.31-2.28.92-3.27.61-1.01,1.43-1.76,2.43-2.28,2.16-1.09,4.36-1.89,6.6-2.43,2.24-.55,4.51-.82,6.81-.82s4.57.27,6.81.82c2.24.54,4.44,1.36,6.6,2.43,1.01.52,1.82,1.28,2.43,2.28.61,1.01.92,2.1.92,3.27v5.87H0ZM4.19,29.38h25.15v-1.68c0-.38-.1-.73-.29-1.05-.19-.31-.44-.57-.75-.73-1.89-.94-3.79-1.66-5.72-2.12-1.93-.46-3.86-.71-5.83-.71s-3.9.23-5.83.71c-1.93.48-3.84,1.17-5.72,2.12-.31.17-.57.42-.75.73-.19.31-.29.67-.29,1.05v1.68h.04ZM16.77,12.62c1.15,0,2.14-.42,2.96-1.24.82-.82,1.24-1.8,1.24-2.96s-.42-2.14-1.24-2.96c-.82-.82-1.8-1.24-2.96-1.24s-2.14.42-2.96,1.24c-.82.82-1.24,1.8-1.24,2.96s.42,2.14,1.24,2.96c.82.82,1.8,1.24,2.96,1.24Z"
        fill="currentColor"
      />
      <path
        d="M44.35,8.28c-.44-1.01-1.05-1.89-1.8-2.64-.73-.75-1.63-1.36-2.64-1.78-2.03-.88-4.49-.88-6.52,0-1.01.44-1.91,1.03-2.66,1.78-.73.73-1.34,1.63-1.78,2.64-.44,1.03-.65,2.12-.65,3.27s.21,2.24.65,3.25c.44,1.03,1.05,1.91,1.78,2.66.75.75,1.66,1.34,2.66,1.78,1.01.44,2.1.65,3.25.65s2.26-.21,3.27-.65c1.01-.44,1.91-1.03,2.64-1.78.75-.75,1.36-1.63,1.8-2.66.42-1.01.65-2.1.65-3.25s-.23-2.24-.65-3.27ZM41.08,7.86c.36.44.65.94.88,1.47.27.71.42,1.47.42,2.22,0,1.61-.54,2.96-1.66,4.07-1.11,1.11-2.45,1.68-4.09,1.68s-2.93-.55-4.07-1.68c-1.13-1.11-1.68-2.45-1.68-4.07s.55-2.96,1.68-4.07c1.01-1.01,2.16-1.55,3.54-1.66v6.98l4.97-4.95Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default CompRegoFullButOpenIcon;
